const LWStage = (initiatives) => {
  const now = new Date();
  const oneWeekAgo = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);

  const rangeGroups = {
    '<not set>': [],
    'LO (Idea)': [],
    'Submitted for L1 approval': [],
    'L1 (Identified)': [],
    'Submitted for L2 approval': [],
    'L2 (Validated)': [],
    'Submitted for L3 approval': [],
    'L3 (Planned)': [],
    'Submitted for L4 approval': [],
    'Submitted for return to L3 approval': [],
    'L4 (Executed)': [],
    'Submitted for L5 approval': [],
    'L5 (Realised)': [],
  };

  initiatives.forEach((initiative) => {
    let lwStage = '<not set>';
    const specificHistory = (initiative.history || [])
      .filter((entry) => entry && entry.action)
      .filter(
        (entry) =>
          entry.action.includes('Changed from L0 to Submitted for L1 Approval') ||
          entry.action.includes('Changed from L1 to Submitted for L2 Approval') ||
          entry.action.includes('Changed from L2 to Submitted for L3 Approval') ||
          entry.action.includes('Changed from L3 to Submitted for L4 Approval') ||
          entry.action.includes('Changed from L4 to Submitted for L5 Approval') ||
          entry.action.includes('Changed from L4 to Submitted for L3 Approval') ||
          entry.action.includes('Changed from Submitted for L1 Approval to L1') ||
          entry.action.includes('Changed from Submitted for L2 Approval to L2') ||
          entry.action.includes('Changed from Submitted for L3 Approval to L3') ||
          entry.action.includes('Changed from Submitted for L4 Approval to L4') ||
          entry.action.includes('Changed from Submitted for L5 Approval to L5') ||
          entry.action.includes('Changed from L1 to L0') ||
          entry.action.includes('Changed from L2 to L1') ||
          entry.action.includes('Changed from L3 to L2') ||
          entry.action.includes('Changed from L4 to L3') ||
          entry.action.includes('Changed from L5 to L4')
      )
      .map((entry) => ({
        action: entry.action,
        timestamp: entry.timestamp,
      }));

    if (specificHistory.length > 0) {
      let previousStage = null;
      let latestTimestamp = null;

      specificHistory.forEach((entry) => {
        const entryTimestamp = new Date(entry.timestamp);

        if (entryTimestamp <= oneWeekAgo) {
          if (entry.action.includes('Changed from L0 to Submitted for L1 Approval')) {
            if (!latestTimestamp || entryTimestamp > latestTimestamp) {
              previousStage = 'LO (Idea)';
              latestTimestamp = entryTimestamp;
            }
          } else if (entry.action.includes('Changed from L1 to Submitted for L2 Approval')) {
            if (!latestTimestamp || entryTimestamp > latestTimestamp) {
              previousStage = 'L1 (Identified)';
              latestTimestamp = entryTimestamp;
            }
          } else if (entry.action.includes('Changed from L2 to Submitted for L3 Approval')) {
            if (!latestTimestamp || entryTimestamp > latestTimestamp) {
              previousStage = 'L2 (Validated)';
              latestTimestamp = entryTimestamp;
            }
          } else if (entry.action.includes('Changed from L3 to Submitted for L4 Approval')) {
            if (!latestTimestamp || entryTimestamp > latestTimestamp) {
              previousStage = 'L3 (Planned)';
              latestTimestamp = entryTimestamp;
            }
          } else if (entry.action.includes('Changed from L4 to Submitted for L5 Approval')) {
            if (!latestTimestamp || entryTimestamp > latestTimestamp) {
              previousStage = 'L4 (Executed)';
              latestTimestamp = entryTimestamp;
            }
          } else if (entry.action.includes('Changed from L4 to Submitted for L3 Approval')) {
            if (!latestTimestamp || entryTimestamp > latestTimestamp) {
              previousStage = 'L4 (Executed)';
              latestTimestamp = entryTimestamp;
            }
          } else if (entry.action.includes('Changed from Submitted for L1 Approval to L1')) {
            if (!latestTimestamp || entryTimestamp > latestTimestamp) {
              previousStage = 'Submitted for L1 approval';
              latestTimestamp = entryTimestamp;
            }
          } else if (entry.action.includes('Changed from Submitted for L2 Approval to L2')) {
            if (!latestTimestamp || entryTimestamp > latestTimestamp) {
              previousStage = 'Submitted for L2 approval';
              latestTimestamp = entryTimestamp;
            }
          } else if (entry.action.includes('Changed from Submitted for L3 Approval to L3')) {
            if (!latestTimestamp || entryTimestamp > latestTimestamp) {
              previousStage = 'Submitted for L3 approval';
              latestTimestamp = entryTimestamp;
            }
          } else if (entry.action.includes('Changed from Submitted for L4 Approval to L4')) {
            if (!latestTimestamp || entryTimestamp > latestTimestamp) {
              previousStage = 'Submitted for L4 approval';
              latestTimestamp = entryTimestamp;
            }
          } else if (entry.action.includes('Changed from Submitted for L5 Approval to L5')) {
            if (!latestTimestamp || entryTimestamp > latestTimestamp) {
              previousStage = 'Submitted for L5 approval';
              latestTimestamp = entryTimestamp;
            }
          } else if (entry.action.includes('Changed from L1 to L0')) {
            if (!latestTimestamp || entryTimestamp > latestTimestamp) {
              previousStage = 'L1 (Identified)';
              latestTimestamp = entryTimestamp;
            }
          } else if (entry.action.includes('Changed from L2 to L1')) {
            if (!latestTimestamp || entryTimestamp > latestTimestamp) {
              previousStage = 'L2 (Validated)';
              latestTimestamp = entryTimestamp;
            }
          } else if (entry.action.includes('Changed from L3 to L2')) {
            if (!latestTimestamp || entryTimestamp > latestTimestamp) {
              previousStage = 'L3 (Planned)';
              latestTimestamp = entryTimestamp;
            }
          } else if (entry.action.includes('Changed from L4 to L3')) {
            if (!latestTimestamp || entryTimestamp > latestTimestamp) {
              previousStage = 'L4 (Executed)';
              latestTimestamp = entryTimestamp;
            }
          } else if (entry.action.includes('Changed from L5 to L4')) {
            if (!latestTimestamp || entryTimestamp > latestTimestamp) {
              previousStage = 'L5 (Realised)';
              latestTimestamp = entryTimestamp;
            }
          }
        }
      });
      if (previousStage) {
        lwStage = previousStage;
      }
    }

    rangeGroups[lwStage].push(initiative);
  });

  return rangeGroups;
};

export default LWStage;
